import { PageHeader } from "../../shared/ui";
import { BugList } from "./BugList";

/**
 * Every bug, across every project.
 *
 * <p>The testing team's screen. A tester covering three projects should not have to open three
 * project pages to find out what is waiting for them, and the worst fault in the organisation is
 * the one to look at first regardless of which project it belongs to.
 */
export function BugsPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Bugs"
        subtitle="Every project, worst first. Severity is how bad it is; priority is how soon it will be picked up."
      />
      <BugList />
    </div>
  );
}
